import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useStoreSellTime = create(
  persist(
    (set, get) => ({
      sellTimeProducts: [],
      invalidTimeProducts: [],
      setSellTimeProducts: (newData) => {
        set((state) => ({
          sellTimeProducts: [...state.sellTimeProducts, ...newData],
        }));
      },
      setInvalidTimeProducts: (newData) => {
        set({ invalidTimeProducts: newData });
      },
      clearSellTimeProducts: () => {
        set({ sellTimeProducts: [] });
      },
      // Marks products the server refused as unavailable. Tiles prefer an entry here
      // over the menu's own flag, and entries are recorded at add-to-cart time, so a
      // product added while available would otherwise keep showing as orderable after a
      // sold-out refusal. Only ever deactivates.
      deactivateSellTimeProducts: (uuids) => {
        if (!uuids || uuids.size === 0) return;
        set((state) => ({
          sellTimeProducts: state.sellTimeProducts.map((product) =>
            uuids.has(product.uuid_product) ? { ...product, is_active: false } : product,
          ),
        }));
      },
      clearInvalidTImeProducts: () => {
        set({ invalidTimeProducts: [] });
      },
      updateSellTimeProducts: (invalidItems) => {
        const sellTimeProducts = get().sellTimeProducts;
        const updatedSellTimeProducts = sellTimeProducts.map((product) => {
          let newInvalid = false;
          invalidItems.map((invalidItem) => {
            if (invalidItem.is_variant && invalidItem.variant_item.length > 0) {
              newInvalid = invalidItem.variant_item.some(
                (varItem) => varItem.uuid_product === product.uuid_product,
              );
            } else {
              // For non-variant products, check by product uuid.
              newInvalid = invalidItems.some(
                (invalidItem) =>
                  invalidItem.uuid_product === product.uuid_product,
              );
            }
          });

          // Keep product inactive if it's already inactive;
          // otherwise, set it inactive if found in invalidItems.
          const newIsActive = product.is_active === false ? false : !newInvalid;

          return {
            ...product,
            is_active: newIsActive,
          };
        });
        set({ sellTimeProducts: updatedSellTimeProducts });
      },
    }),
    {
      name: 'list_selltime',
    },
  ),
);
